export interface FeatureDef {
	key: string;
	label: string;
}

export type PermissionMatrix = Record<string, Record<string, boolean>>;

export interface PermissionUpdate {
	role: string;
	feature: string;
	allowed: boolean;
}

/**
 * Sinkronisasi NOC tetap eksklusif role admin: sel role lain dikunci di UI.
 * Satu-satunya pengecualian yang tersisa di halaman ini — hardcode lama "admin
 * selalu akses penuh" sudah dicabut, sebab izin role admin kini dibaca dari DB
 * dan justru harus bisa diatur superadmin.
 */
export function isCellLocked(role: string, feature: string): boolean {
	return role !== "admin" && feature === "sync-noc";
}

/** Nilai checkbox: sel terkunci selalu mati, sisanya ikut matriks. */
export function cellChecked(
	matrix: PermissionMatrix,
	role: string,
	feature: string,
): boolean {
	if (isCellLocked(role, feature)) return false;
	return matrix[role]?.[feature] ?? false;
}

/**
 * Payload PUT matriks: seluruh kombinasi role × fitur yang tidak terkunci,
 * termasuk baris role `admin` — tanpa itu izin admin tidak akan pernah
 * tersimpan dan pembatasan menu tidak punya sumber data.
 */
export function buildPermissionPayload(
	roles: readonly string[],
	features: readonly FeatureDef[],
	matrix: PermissionMatrix,
): PermissionUpdate[] {
	const updates: PermissionUpdate[] = [];
	for (const role of roles) {
		for (const f of features) {
			if (isCellLocked(role, f.key)) continue;
			updates.push({
				role,
				feature: f.key,
				allowed: matrix[role]?.[f.key] ?? false,
			});
		}
	}
	return updates;
}
